import { whenRefAvailable } from "@/utilities";
import { type Ref } from "vue";
import type Dialog from "@/components/basics/Dialog.vue";
import type DialogFeedback from "@/components/basics/DialogFeedback.vue";

type DialogComponent = typeof Dialog;
type DialogFeedbackComponent = typeof DialogFeedback;

export function useDialogControls(dialogRef: Ref<InstanceType<DialogComponent | DialogFeedbackComponent> | null>) {
  const open = () => whenRefAvailable(dialogRef).then((dialog) => dialog.value.open());
  const close = () => whenRefAvailable(dialogRef).then((dialog) => dialog.value.close());

  return {
    open,
    close,
    dialogRef,
  };
}
